import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { SubtitleLayout } from '../../components/SubtitleLayout';
import { ContentLayout } from '../../components/ContentLayout';
import { trackLoginNeedHelp } from '../../utils/tracking';
import { HelpContainer } from '../HelpContainer';
export function TokenExpiredErrorView(_ref) {
  var changeViewToPhoneAuth = _ref.changeViewToPhoneAuth;
  return /*#__PURE__*/React.createElement(ViewContainer, null, /*#__PURE__*/React.createElement(TitleContainer, null), /*#__PURE__*/React.createElement(SubtitleLayout, null, "\u041A\u043E\u0434 \u0438\u0437 \u0441\u043C\u0441 \u0443\u0441\u0442\u0430\u0440\u0435\u043B, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0442\u0435\u043B\u0435\u0444\u043E\u043D"), /*#__PURE__*/React.createElement(ContentLayout, null, /*#__PURE__*/React.createElement(Button, {
    "data-name": "BackToAccountSelect",
    theme: "fill_primary",
    fullWidth: true,
    onClick: changeViewToPhoneAuth
  }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C")), /*#__PURE__*/React.createElement(HelpContainer, {
    onClick: trackLoginNeedHelp
  }));
}